import MicroModal from 'micromodal'

const cmJapanPricesTable = {
    component: null,

    init: function (element) {
        const _ = this
        _.component = element

        MicroModal.init({
            onShow: function (modal) {
                document.getElementsByClassName("loader-overlay")[0].style.display = 'block'
                document.getElementById('full_data').classList.add('active')
                setTimeout(function () {
                    let ele = document.querySelector('.fund-chart-modal.modal-active')
                    document.querySelector(".Chart-fund-title h2").innerHTML = ele.getAttribute('data-fund-name')
                    BeforeChartLoads(ele)
                    setTimeout(function () {
                        document.getElementsByClassName("loader-overlay")[0].style.display = 'none'
                        document.getElementsByClassName("chart-container")[0].style.display = 'block'
                    }, 500)
                }, 100)
                setDateOffsets()
            },
            onClose: function (modal) {
                clearChartData()
                document.getElementsByClassName("chart-container")[0].style.display = 'none'
                document.querySelector(".Chart-fund-title h2").innerHTML = ' '
            }, // [2]
            openTrigger: 'data-custom-open', // [3]
            closeTrigger: 'data-custom-close', // [4]
            openClass: 'is-open', // [5]
            disableScroll: true, // [6]
            disableFocus: false, // [7]
            awaitOpenAnimation: true, // [8]
            awaitCloseAnimation: true, // [9]
            debugMode: true // [10]
        })

        MicroModal.show('nav-chart-modal') // [1]
        MicroModal.close('nav-chart-modal') // [2]
        // const closebtn = document.querySelector('.modal__close')
        // MicroModal.close(closebtn)
        var labelsDataArray = []
        var NavDataArray = []
        var NavReInvestedDataArray = []
        var AumDataArray = []
        let AminValue;
        let AmaxValue;
        let AstepSize;
        let BminValue;
        let BmaxValue;
        let BstepSize;

        const data = {
            labels: labelsDataArray,
            datasets: [
                {
                    type: 'line',
                    label: document.querySelector('.line.one').getAttribute('data-legend-title'),
                    yAxisID: 'A',
                    pointRadius: 0,
                    data: NavDataArray,
                    backgroundColor: 'rgba(0, 41, 86, 1)',
                    borderColor: 'rgba(0, 41, 86, 1)',
                    borderWidth: 2,
                    fill: false,
                    lineTension: 0.5,
                },
                {
                    type: 'line',
                    label: document.querySelector('.line.two').getAttribute('data-legend-title'),
                    yAxisID: 'A',
                    pointRadius: 0,
                    data: NavReInvestedDataArray,
                    backgroundColor: 'rgba(0, 149, 58, 1)',
                    borderColor: 'rgba(0, 149, 58, 1)',
                    borderWidth: 2,
                    fill: false,
                    lineTension: 0.5,
                },
                {
                    type: 'line',
                    label: document.querySelector('.line.three').getAttribute('data-legend-title'),
                    yAxisID: 'B',
                    pointRadius: 0,
                    data: AumDataArray,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    borderColor: 'rgba(0, 0, 0, 0)',
                    borderWidth: 3,
                    fill: true,
                    lineTension: 0.5,
                },
            ]
        }

        const chart = document.getElementById('jpNavChart')
        const ctx = chart.getContext('2d')
        ctx.height = 'auto'
        const navChart = new Chart(ctx, {
            type: 'line',
            data: data,
            plugins: [ChartDataLabels],
            options: {
                responsive: true,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                animation: {
                    duration: 0
                },
                scales: {
                    x: {
                        type: "time",
                        time: {
                            unit: 'month',
                            stepSize: 60,
                            displayFormats: {
                                month: 'YYYY/MM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                        },
                    },
                    A: {
                        id: "A",
                        type: 'linear',
                        position: 'left',
                        ticks: {
                            callback: function (label, index, labels) {
                                return label.toLocaleString()
                            },
                        }
                    },
                    B: {
                        id: "B",
                        type: 'linear',
                        position: 'right',
                    },
                },
                plugins: {
                    datalabels: {
                        display: false,
                        // formatter: function (value, context) {
                        //     return ''
                        // },
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label;
                                if (label) {
                                    label += ': ' + context.parsed.y.toLocaleString();
                                }
                                return label;
                            },
                        },
                        mode: 'index',
                        intersect: false,
                    }
                }
            }
        })

        async function BeforeChartLoads(ele) {
            await getFundDataArray(ele)
            navChart.data.labels = labelsDataArray
            navChart.data.datasets[0].data = NavDataArray
            navChart.data.datasets[1].data = NavReInvestedDataArray
            navChart.data.datasets[2].data = AumDataArray
            setAxesProperties(ele)
            updateDateRange()
            navChart.update()
            setDateOffsets()
            //console.log(navChart)
        }
        async function getFundDataArray(ele) {
            let fundCode = ele.getAttribute('data-fund-code')
            let fundBlockId = ele.getAttribute('data-fund-blockid')
            let baseUrl = '/api/FundTableChart/GetFundData?fundcode=' + fundCode + '&fundblockid=' + fundBlockId
            if (fundCode != null && fundBlockId != null) {
                const response = await window.fetch(baseUrl)
                const data = await response.json()
                labelsDataArray = data.DateLabelsList
                NavDataArray = data.NavData
                NavReInvestedDataArray = data.NavReinvestedData
                AumDataArray = data.AumData
                AminValue = data.AminValue
                AmaxValue = data.AmaxValue
                AstepSize = data.AstepSize
                BminValue = data.BminValue
                BmaxValue = data.BmaxValue
                BstepSize = data.BstepSize
            }
        }
        function setAxesProperties(ele) {
            let fundCode = ele.getAttribute('data-fund-code')
            switch (fundCode) {
                case '520001':
                    navChart.scales.x.options.time.stepSize = 60
                    navChart.scales.A.options.ticks.stepSize = (AstepSize == null ? null : parseInt(AstepSize))
                    navChart.scales.B.options.ticks.stepSize = (BstepSize == null ? null : parseInt(BstepSize))
                    navChart.options.scales.A.min = (AminValue == null ? null : parseInt(AminValue))
                    navChart.options.scales.A.max = (AmaxValue == null ? null : parseInt(AmaxValue))
                    navChart.options.scales.B.min = (BminValue == null ? null : parseInt(BminValue))
                    navChart.options.scales.B.max = (BmaxValue == null ? null : parseInt(BmaxValue))
                    break
                case '628001':
                    navChart.scales.x.options.time.stepSize = 36
                    navChart.scales.A.options.ticks.stepSize = (AstepSize == null ? null : parseInt(AstepSize))
                    navChart.scales.B.options.ticks.stepSize = (BstepSize == null ? null : parseInt(BstepSize))
                    navChart.options.scales.A.min = (AminValue == null ? null : parseInt(AminValue))
                    navChart.options.scales.A.max = (AmaxValue == null ? null : parseInt(AmaxValue))
                    navChart.options.scales.B.min = (BminValue == null ? null : parseInt(BminValue))
                    navChart.options.scales.B.max = (BmaxValue == null ? null : parseInt(BmaxValue))
                    break
                case '521331':
                    navChart.scales.x.options.time.stepSize = 60
                    navChart.scales.A.options.ticks.stepSize = (AstepSize == null ? null : parseInt(AstepSize))
                    navChart.scales.B.options.ticks.stepSize = (BstepSize == null ? null : parseInt(BstepSize))
                    navChart.options.scales.A.min = (AminValue == null ? null : parseInt(AminValue))
                    navChart.options.scales.A.max = (AmaxValue == null ? null : parseInt(AmaxValue))
                    navChart.options.scales.B.min = (BminValue == null ? null : parseInt(BminValue))
                    navChart.options.scales.B.max = (BmaxValue == null ? null : parseInt(BmaxValue))
                    break
                case '725001':
                    navChart.scales.x.options.time.stepSize = 24
                    navChart.scales.A.options.ticks.stepSize = (AstepSize == null ? null : parseInt(AstepSize))
                    navChart.scales.B.options.ticks.stepSize = (BstepSize == null ? null : parseInt(BstepSize))
                    navChart.options.scales.A.min = (AminValue == null ? null : parseInt(AminValue))
                    navChart.options.scales.A.max = (AmaxValue == null ? null : parseInt(AmaxValue))
                    navChart.options.scales.B.min = (BminValue == null ? null : parseInt(BminValue))
                    navChart.options.scales.B.max = (BmaxValue == null ? null : parseInt(BmaxValue))
                    break
                default:
                    break
            }
        }
        function clearChartData() {
            navChart.data.labels = []
            navChart.data.datasets[0].data = []
            navChart.data.datasets[1].data = []
            navChart.data.datasets[2].data = []
            let filterelementsList = document.getElementsByClassName("chartFilterButton")
            filterelementsList.forEach(function (element) {
                element.classList.remove("active")
            })
            AminValue = null
            AmaxValue = null
            AstepSize = null
            BminValue = null
            BmaxValue = null
            BstepSize = null
            navChart.update()
        }

        function setDateOffsets() {
            const now = new Date()
            let oneMonthDate = subtractMonths(now, 1)
            let threeMonthDate = subtractMonths(now, 3)
            let sixMonthDate = subtractMonths(now, 6)
            let oneYearDate = subtractMonths(now, 12)
            let threeYearDate = subtractMonths(now, 36)
            let fiveYearDate = subtractMonths(now, 60)

            document.getElementById("one_month").setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, oneMonthDate))
            document.getElementById('three_months').setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, threeMonthDate))
            document.getElementById('six_months').setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, sixMonthDate))
            document.getElementById('one_year').setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, oneYearDate))
            document.getElementById('three_years').setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, threeYearDate))
            document.getElementById('five_years').setAttribute('data-index', labelsDataArray.length - nearestDate(labelsDataArray, fiveYearDate))
            document.getElementById('full_data').setAttribute('data-index', labelsDataArray.length)
        }
        function subtractMonths(d, n) {
            let dt = new Date(d.getTime())
            dt.setMonth(dt.getMonth() - n)
            return dt
        }
        function nearestDate(dates, target) {
            if (!target) {
                target = Date.now()
            }
            else if (target instanceof Date) {
                target = target.getTime()
            }
            let nearest = Infinity
            let winner = -1
            dates.forEach(function (date, index) {
                date = new Date(date)
                if (date instanceof Date) {
                    date = date.getTime()
                }
                let distance = Math.abs(date - target)
                if (distance < nearest) {
                    nearest = distance
                    winner = index
                }
            })
            return winner
        }

        const btnList = document.querySelectorAll('.fund-chart-modal')
        btnList.forEach(x => x.addEventListener('click', function () {
            btnList.forEach(a => {
                a.classList.remove("modal-active");
            })
            x.classList.add("modal-active");
        }))
        document.getElementsByClassName("chartFilterButton").forEach(function (item) {
            item.addEventListener("click", clickedFilter)
        })

        function clickedFilter(e) {
            // remove animation for updates. it looks funky
            //modal.style.animation.duration = 0
            let target = e.target
            let index = target.getAttribute('data-index')
            let xStep = target.getAttribute('data-x-step')
            let full = target.getAttribute('id') === 'full_data'
            // set styles to filter buttons
            let filterelementsList = document.getElementsByClassName("chartFilterButton")
            filterelementsList.forEach(function (element) {
                element.classList.remove("active")
            })
            target.classList.toggle('active')
            if (index != null) {
                navChart.data.labels = !full ? labelsDataArray.slice(0, Math.max(labelsDataArray.length - index, 0)) : labelsDataArray
                navChart.data.datasets[0].data = !full ? NavDataArray.slice(0, Math.max(NavDataArray.length - index, 0)) : NavDataArray
                navChart.data.datasets[1].data = !full ? NavReInvestedDataArray.slice(0, Math.max(NavReInvestedDataArray.length - index, 0)) : NavReInvestedDataArray
                navChart.data.datasets[2].data = !full ? AumDataArray.slice(0, Math.max(0, AumDataArray.length - index, 0)) : AumDataArray
                navChart.scales.x.options.time.stepSize = xStep
                updateDateRange()
                navChart.update()
            }
        }
        function updateDateRange() {
            let chartLabels = navChart.data.labels
            if (chartLabels != null && chartLabels.length > 0) {
                navChart.chartDateRangeContent = chartLabels[chartLabels.length - 1].split('T')[0].replaceAll('-', '/') + ' - ' + chartLabels[0].split('T')[0].replaceAll('-', '/')
                document.querySelector(".jpNavDateRange p").innerHTML = navChart.chartDateRangeContent
            }
            else {
                document.querySelector(".jpNavDateRange p").innerHTML = "No Data Found"
            }
        }
        updateDateRange()
    },
}
export default cmJapanPricesTable
